import {css} from 'aphrodite';
import React from 'react';

import ExtractByTypename from 'graphql-client/ExtractByTypename';
import Col from 'ui-library/bs/Col';
import Label from 'ui-library/bs/Label';
import Row from 'ui-library/bs/Row';
import * as Headers from 'ui-library/Headers';

import {ProcessTaskDetailsQuery} from './graphql/__generated/ProcessTaskDetailsQuery';
import {getMetadataRows, getSummaryRows} from './processes-platform/getTaskDetailsSections';
import {PROCESS_TASK_DETAILS_PAGE_STYLES} from './processes-platform/ProcessTaskDetailsPageConstants';
import {UpdateTaskParams} from './utils/updateTaskDetailsTask';

type ProcessTaskGql = ExtractByTypename<ProcessTaskDetailsQuery['processTask'], 'ProcessTaskNode'>;

export interface ProcessTaskDetailsColumnProps {
  processTask: ProcessTaskGql;
  onUpdateTask: (updatedTask: UpdateTaskParams) => Promise<void>;
}

interface DetailsRowContent {
  label: string;
  component: JSX.Element;
}

interface ProcessTaskDetailsSectionProps {
  title: string;
  content: Array<DetailsRowContent>;
}

export function ProcessTaskDetailsSection(props: ProcessTaskDetailsSectionProps): JSX.Element {
  return (
    <div className={css(PROCESS_TASK_DETAILS_PAGE_STYLES.sectionWrapper)}>
      <div className="metadata-section">
        <Headers.Header2 className={css(PROCESS_TASK_DETAILS_PAGE_STYLES.sectionHeader)}>
          {props.title}
        </Headers.Header2>
        {props.content.map(({label, component}, index) => (
          <Row key={index} className={css(PROCESS_TASK_DETAILS_PAGE_STYLES.rowWrapper)}>
            <Col className={css(PROCESS_TASK_DETAILS_PAGE_STYLES.detailsColumnWrapper)} sm={3}>
              <Label className={css(PROCESS_TASK_DETAILS_PAGE_STYLES.rowHeight)}>{label}</Label>
            </Col>
            <Col md={7} sm={4}>
              {component}
            </Col>
          </Row>
        ))}
      </div>
    </div>
  );
}

export function ProcessTaskDetailsMetadata(props: ProcessTaskDetailsColumnProps): JSX.Element {
  return <ProcessTaskDetailsSection title="Metadata" content={getMetadataRows(props.processTask)} />;
}

export function ProcessTaskDetailsSummary(props: ProcessTaskDetailsColumnProps): JSX.Element {
  return (
    <ProcessTaskDetailsSection
      title="Summary"
      content={getSummaryRows(props.processTask, props.onUpdateTask)}
    />
  );
}
